import { all, fork } from 'redux-saga/effects';
import { CarPolicyClaimSaga } from './CarPolicyClaim';
import { PersonalAccidentPolicyClaimSaga } from './PersonalAccidentPolicyClaim';
import { CancerPolicyClaimSaga } from './CancerPolicyClaim';
import { HealthPolicyClaimSaga } from './HealthPolicyClaim';

export default function* () {
  yield all([
    fork(CarPolicyClaimSaga),
    fork(PersonalAccidentPolicyClaimSaga),
    fork(CancerPolicyClaimSaga),
    fork(HealthPolicyClaimSaga),
  ]);
}
